"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUtmTags = void 0;
const getUtmTags = () => {
    var _a, _b, _c, _d, _e, _f;
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.keys.length === 0) {
        return undefined;
    }
    return {
        utmCampaign: (_a = searchParams.get("utm_campaign")) !== null && _a !== void 0 ? _a : undefined,
        utmContent: (_b = searchParams.get("utm_content")) !== null && _b !== void 0 ? _b : undefined,
        utmId: (_c = searchParams.get("utm_id")) !== null && _c !== void 0 ? _c : undefined,
        utmMedium: (_d = searchParams.get("utm_medium")) !== null && _d !== void 0 ? _d : undefined,
        utmSource: (_e = searchParams.get("utm_source")) !== null && _e !== void 0 ? _e : undefined,
        utmTerm: (_f = searchParams.get("utm_term")) !== null && _f !== void 0 ? _f : undefined
    };
};
exports.getUtmTags = getUtmTags;
//# sourceMappingURL=utm-tags.js.map